// Posts to every preview iframe with targetOrigin pinned to the iframe's own origin.
export function postMessageToPreviewIframes(message) {
  document.querySelectorAll("iframe[data-preview-iframe]").forEach((iframe) => {
    const src = iframe.src;
    if (!src) return;
    let origin;
    try {
      origin = new URL(src).origin;
    } catch {
      return;
    }
    iframe.contentWindow?.postMessage(message, origin);
  });
}
